// export const base = "https://7ba8a46ec606.ngrok-free.app/commoncova/user/highlifehealth" // NEW BASE URL
// export const base = "https://api.cannalogic.co/commoncova/user/highlifehealth"; // NEW BASE URL

export const base = "https://cannabis.demo-7.com/user/highlifehealth" // NEW BASE URL

// export const base = "https://2ed4-180-151-243-87.ngrok-free.app/commoncova/user/highlifehealth" // NEW BASE URL

export let base1 = "https://api.uttarakhandherbs.com/common/cova/"; // For Live purposes only
